import { render, staticRenderFns } from "./service_ztsbch.vue?vue&type=template&id=9b00eeba"
import script from "./service_ztsbch.vue?vue&type=script&lang=js"
export * from "./service_ztsbch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports